import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getCityLeaguesList } from '../../api/getCityLeaguesList';

import HeaderTopic from '../../partials/HeaderTopic';

import styles from './CityLeaguesList.module.css';
import BasicButtons from '../../partials/BasicButtons';
import { userLeague } from '../../api/userLeague';

function CityLeaguesList(props) {
  const { user, setLeague, refreshStates } = props;
  const [cityLeagues, setCityLeagues] = React.useState([]);

  const { cityId } = useParams();
  const history = useHistory();

  React.useEffect(() => {
    let mounted = true;
    if (cityId && history) {
      if (user.player.league !== null) {
        const leagueId = user.player.league;
        userLeague(leagueId).then(data => {
          if (data.error) {
          } else {
            setLeague(data);
            const url = `/leagues/${leagueId}`;
            history.push(url);
          }
        });
      } else {
        getCityLeaguesList(cityId).then(data => {
          if (data.error) {
          } else {
            if (data.length === 1) {
              if (mounted) {
                setLeague(data[0]);
                history.push(`/leagues/${data[0].id}`);
              }
            } else {
              setCityLeagues(data);
            }
          }
        });
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [user, cityId, history, setLeague]);

  const redirectToLeague = league => {
    setLeague(league);
    history.push(`/leagues/${league.id}`);
  };

  const showLeaguesForCity = cityLeagues?.map(league => (
    <li
      key={league.id}
      onClick={() => redirectToLeague(league)}
    >
      <h2>ליגת {league.name}</h2>
      <h4>יישוב: {league.city_name}</h4>
    </li>
  ));

  return (
    <div className={styles.cityLeaguesList}>
      <div className={styles.bgVisual}></div>
      <HeaderTopic topic="בחר ליגה בעיר" />
      <BasicButtons user={user} refreshStates={refreshStates} />

      <div className={styles.list}>
        {cityLeagues !== null && cityLeagues.length > 1 ? (
          <ul>{showLeaguesForCity}</ul>
        ) : (
          <div className={styles.loadingText}>טוען את הליגות בעיר שלך</div>
        )}
      </div>
    </div>
  );
}

export default CityLeaguesList;
